import { render, staticRenderFns } from "./Drugs.vue?vue&type=template&id=3f8cd94c&scoped=true"
import script from "./Drugs.vue?vue&type=script&lang=js"
export * from "./Drugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8cd94c",
  null
  
)

export default component.exports